module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAGZQTFRFAAAAHAAAHhEDHRQCAAAAHRICIRcIWlFGg311WVFFHhMDUkk93tza////+fn4/////////////////v7+/f39/////v7+////////g310HRQC/////////v7++fn4////////4N7cUQba+AAAACJ0Uk5TAAlMcwFx7v///6P+/////PD0/fj7+f77+v9y8un1+u/+/+Lh+jIAAAB5SURBVHicXY/bEoIwDETTlpZCu1wURQEF/v8nSSrMIPuUM7nshoiltDFa0U+Zdbn3hbNZojJEsGIohW2ogLppUQXLey7e7tLtEJ0ineMhhCdQaDIePXZ5I/g68D3I8HggD/OpKdWfdIqNvjPTUicjibGeYlxC/r2wAc1MBv/HggqvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_select.png
// module id = QQf9
// module chunks = 0